export default __webpack_public_path__ + "static/media/eat24.652ea114.png";